module.exports = __webpack_public_path__ + "img/traffic-light-solid.3f672e81.svg";